<template lang="pug">
.field
  el-form
    el-form-item(label='Title')
      el-input(v-model='field.title' :disabled='disabled')

    el-form-item(label='Description')
      el-input(v-model='field.properties.description.value' :disabled='disabled')

    el-row(:gutter='10')
      el-col(:span='12')
        el-form-item(label='Steps')
          el-input-number(v-model='field.properties.steps.value' :min='1' :max='10' :disabled='disabled')
      el-col(:span='12')
        el-form-item(label='Shape')
          el-select(v-model='field.properties.shape.value' :disabled='disabled')
            el-option(label='Star' value='star') Star

</template>

<script>
export default {
  props: {
    field: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss"></style>
